export default {
    merchZoneLoading: false,
    merchZoneError: false,
    merchZone: null,
    availability: null,
};